import React from 'react';
import { Link } from 'react-router-dom';

const GDPR = ({ language }) => {
    const content = {
        en: {
            title: "GDPR & Privacy Policy",
            subtitle: "Information about the processing of personal data",
            sections: [
                {
                    heading: "1. Data Controller",
                    text: "The data controller is BEYSTRENG s.r.o., with its registered office at Na Kovárně 951/27, Plzeň 312 00, Czech Republic, ID No.: 21421005 (hereinafter referred to as the 'Controller')."
                },
                {
                    heading: "2. Personal Data Processed",
                    text: "We process personal data that you provide to us directly, for example when contacting us via email or contact form. This typically includes your name, email address, phone number, and the content of your message."
                },
                {
                    heading: "3. Purpose of Processing",
                    text: "The primary purpose of processing your personal data is to respond to your inquiries, provide our services, and fulfill legal obligations. We may also use cookies to improve your experience on our website."
                },
                {
                    heading: "4. Google Analytics & Cookies",
                    text: "This website uses Google Analytics, a web analytics service provided by Google LLC. Google Analytics uses cookies to analyze how users use the site. The information generated by the cookie about your use of the website (including your IP address) will be transmitted to and stored by Google on servers in the United States. We use this information to evaluate your use of the website, compile reports on website activity, and provide other services relating to website activity and internet usage. Google may also transfer this information to third parties where required to do so by law, or where such third parties process the information on Google's behalf."
                },
                {
                    heading: "5. Your Rights",
                    text: "Under the GDPR, you have the right to access your personal data, rectify inaccurate data, erasure ('right to be forgotten'), restriction of processing, data portability, and to object to processing. You also have the right to lodge a complaint with a supervisory authority."
                },
                {
                    heading: "6. Contact Us",
                    text: "If you have any questions about how we handle your personal data, please contact us at info@beystreng.com."
                }
            ],
            back: "Back to Home"
        },
        cs: {
            title: "GDPR a Zásady ochrany osobních údajů",
            subtitle: "Informace o zpracování osobních údajů",
            sections: [
                {
                    heading: "1. Správce údajů",
                    text: "Správcem osobních údajů je společnost BEYSTRENG s.r.o., se sídlem Na Kovárně 951/27, Plzeň 312 00, Česká republika, IČO: 21421005 (dále jen 'Správce')."
                },
                {
                    heading: "2. Zpracovávané osobní údaje",
                    text: "Zpracováváme osobní údaje, které nám poskytnete přímo, například při kontaktování prostřednictvím e-mailu nebo kontaktního formuláře. Obvykle se jedná o jméno, e-mailovou adresu, telefonní číslo a obsah vaší zprávy."
                },
                {
                    heading: "3. Účel zpracování",
                    text: "Hlavním účelem zpracování vašich osobních údajů je reakce na vaše dotazy, poskytování našich služeb a plnění zákonných povinností. Můžeme také používat cookies pro zlepšení vašeho zážitku na našem webu."
                },
                {
                    heading: "4. Google Analytics a Cookies",
                    text: "Tento web používá službu Google Analytics, poskytovanou společností Google LLC. Google Analytics používá soubory cookies k analýze způsobu užívání webu. Informace vygenerované souborem cookie o užívání webu (včetně vaší IP adresy) budou přeneseny a uloženy společností Google na servery ve Spojených státech. Tyto informace používáme k vyhodnocování užívání webu a vytváření zpráv o jeho aktivitě. Google může také poskytnout tyto informace třetím stranám, pokud to vyžaduje zákon nebo pokud třetí strany zpracovávají tyto informace pro Google."
                },
                {
                    heading: "5. Vaše práva",
                    text: "Podle GDPR máte právo na přístup k vašim osobním údajům, opravu nepřesných údajů, výmaz ('právo být zapomenut'), omezení zpracování, přenositelnost údajů a vznést námitku proti zpracování. Máte také právo podat stížnost u dozorového úřadu."
                },
                {
                    heading: "6. Kontaktujte nás",
                    text: "Máte-li jakékoli dotazy ohledně způsobu, jakým nakládáme s vašimi osobními údaji, kontaktujte nás na info@beystreng.com."
                }
            ],
            back: "Zpět na úvod"
        },
        de: {
            title: "DSGVO & Datenschutzerklärung",
            subtitle: "Informationen zur Verarbeitung personenbezogener Daten",
            sections: [
                {
                    heading: "1. Verantwortlicher",
                    text: "Der Verantwortliche für die Datenverarbeitung ist BEYSTRENG s.r.o. mit Sitz in Na Kovárně 951/27, Plzeň 312 00, Tschechische Republik, ID-Nr.: 21421005 (im Folgenden als 'Verantwortlicher' bezeichnet)."
                },
                {
                    heading: "2. Verarbeitete personenbezogene Daten",
                    text: "Wir verarbeiten personenbezogene Daten, die Sie uns direkt zur Verfügung stellen, zum Beispiel bei der Kontaktaufnahme per E-Mail oder Kontaktformular. Dies umfasst in der Regel Ihren Namen, Ihre E-Mail-Adresse, Telefonnummer und den Inhalt Ihrer Nachricht."
                },
                {
                    heading: "3. Zweck der Verarbeitung",
                    text: "Der primäre Zweck der Verarbeitung Ihrer personenbezogenen Daten besteht darin, auf Ihre Anfragen zu antworten, unsere Dienstleistungen zu erbringen und gesetzliche Verpflichtungen zu erfüllen. Wir können auch Cookies verwenden, um Ihre Erfahrung auf unserer Website zu verbessern."
                },
                {
                    heading: "4. Google Analytics & Cookies",
                    text: "Diese Website verwendet Google Analytics, einen Webanalysedienst der Google LLC. Google Analytics verwendet Cookies, um zu analysieren, wie Benutzer die Website nutzen. Die durch das Cookie erzeugten Informationen über Ihre Nutzung der Website (einschließlich Ihrer IP-Adresse) werden an Server von Google in den Vereinigten Staaten übertragen und dort gespeichert. Wir verwenden diese Informationen, um Ihre Nutzung der Website auszuwerten, Berichte über die Website-Aktivität zusammenzustellen und andere Dienstleistungen im Zusammenhang mit der Website-Aktivität und der Internetnutzung zu erbringen. Google kann diese Informationen auch an Dritte weitergeben, sofern dies gesetzlich vorgeschrieben ist oder diese Dritten die Daten im Auftrag von Google verarbeiten."
                },
                {
                    heading: "5. Ihre Rechte",
                    text: "Gemäß der DSGVO haben Sie das Recht auf Auskunft über Ihre personenbezogenen Daten, auf Berichtigung unrichtiger Daten, auf Löschung ('Recht auf Vergessenwerden'), auf Einschränkung der Verarbeitung, auf Datenübertragbarkeit und auf Widerspruch gegen die Verarbeitung. Sie haben auch das Recht, eine Beschwerde bei einer Aufsichtsbehörde einzureichen."
                },
                {
                    heading: "6. Kontaktieren Sie uns",
                    text: "Wenn Sie Fragen dazu haben, wie wir mit Ihren personenbezogenen Daten umgehen, kontaktieren Sie uns bitte unter info@beystreng.com."
                }
            ],
            back: "Zurück zur Startseite"
        }
    };

    const t = content[language] || content.en;

    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
                <div className="px-6 py-8 sm:p-10">
                    <div className="border-b border-gray-200 pb-6 mb-6">
                        <h1 className="text-3xl font-bold text-gray-900">{t.title}</h1>
                        <p className="mt-2 text-lg text-gray-600">{t.subtitle}</p>
                    </div>

                    <div className="space-y-8">
                        {t.sections.map((section, index) => (
                            <div key={index}>
                                <h2 className="text-xl font-semibold text-gray-900 mb-2">{section.heading}</h2>
                                <p className="text-gray-600 leading-relaxed">{section.text}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-10 pt-6 border-t border-gray-200">
                        <Link
                            to={`/${language}`}
                            className="text-blue-600 hover:text-blue-800 font-semibold transition-colors flex items-center gap-2"
                        >
                            ← {t.back}
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GDPR;
